module.exports = require('./bundle-url').getBundleURL() + require('./relative-path')("KoI75", "7C0qf")